import { render, staticRenderFns } from "./sfc-header-no-nav.vue?vue&type=template&id=55bd2441&scoped=true&lang=pug&"
import script from "./sfc-header-no-nav.vue?vue&type=script&lang=js&"
export * from "./sfc-header-no-nav.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header-no-nav.vue?vue&type=style&index=0&id=55bd2441&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd2441",
  null
  
)

export default component.exports